import { z } from 'zod';

import { preprocessEmptyStringAsUndefined } from '@dealstack/shared/lib/common/common.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { SecurityInterestDefinitionPrincipal } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const SecurityLiquidationPreferenceShape = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) =>
	z
		.object({
			principal: z.nativeEnum(SecurityInterestDefinitionPrincipal),
			principalValue: z.preprocess(
				preprocessEmptyStringAsUndefined,
				z.number().nonnegative().optional()
			),
		})
		.refine(
			(data) => {
				if (data.principal !== SecurityInterestDefinitionPrincipal.ISSUE_COST_PER_UNIT) {
					return data.principalValue !== undefined;
				}

				return true;
			},
			{
				message: tCapManage('securities.interest_definition.validation.principal.required'),
				path: ['principalValue'],
			}
		);

export type SecurityLiquidationPreferenceFormDto = z.infer<
	ReturnType<typeof SecurityLiquidationPreferenceShape>
>;
